module.exports = __webpack_public_path__ + "media/images/backgrounds/angle-top-right-inner-dark-dc938144c2e3b6ad5530ef4d131ea21e.svg";